import { updateMockExamApi } from "@/api/services/admin/learning-content";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toast } from "@/utils/toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type TUpdateMockExamMemoParams = {
  internalMemo: string;
};

/**
 * Hook to update only the memo field of a mock exam.
 * Uses PUT with partial payload (BE supports partial update via undefined check).
 * Designed for blur-to-save on the detail page's 社内メモ field.
 */
export const useUpdateMockExamMemo = (industryId?: string, mockExamId?: string) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ internalMemo }: TUpdateMockExamMemoParams) => {
      if (!industryId || !mockExamId) return Promise.reject(new Error("Missing industryId or mockExamId"));
      return updateMockExamApi(industryId, mockExamId, { internalMemo });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_MOCK_EXAM, industryId, mockExamId] });
      toast.success(API_SUCCESS_MESSAGE);
    },
    onError: (error) => {
      showError(error);
    },
  });

  return mutation;
};
